;(function () {
    function BusinessAreaSelector() {
        const DEFAULT_BUSINESS_AREA = 'privatkunden'

        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * Defines the current business area and sets it for further usage
         *
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            let businessArea = _this.getCurrentBusinessArea()
            if (businessArea == null) {
                businessArea = _this.getStoredBusinessArea()
            }
            if (businessArea == null) {
                businessArea = DEFAULT_BUSINESS_AREA
            }
            _this.storeBusinessArea(businessArea)
            _this.setBusinessAreaOnElements(businessArea)

            // Track the Page view with the current business area
            _this.initPageViewTracking(businessArea)
        }

        /**
         * Fire a page view tracking event with the help of the PageViewTracking script.
         *
         * For the PageViewTracking script to be callable it needs to be available - obviously. So we check if it's
         * already available, otherwise listen for the pageViewTrackingLoaded event that is fired by the
         * PageViewTracking script once it is initialized
         *
         * @method initPageViewTracking
         * @param {string} businessArea
         * @returns {undefined}
         */
        this.initPageViewTracking = function (businessArea) {
            if (window.Energy.PageViewTracking !== undefined) {
                new window.Energy.PageViewTracking(businessArea)
            } else {
                window.addEventListener('pageViewTrackingLoaded', function () {
                    new window.Energy.PageViewTracking(businessArea)
                })
            }
        }

        /**
         * Receives business area from local stroage
         * @returns {string|null}
         */
        this.getStoredBusinessArea = function () {
            return localStorage.getItem('businessArea')
        }

        /**
         * Returns currently selected business area, if available
         * @returns {string|null}
         */
        this.getCurrentBusinessArea = function () {
            const activeBusinessArea = document.querySelector('[rel="active-business-area"]')
            if (activeBusinessArea !== null) {
                return activeBusinessArea.getAttribute('data-active-for-business-area')
            }
            return null
        }

        /**
         * Stores business area to local storage
         * @param businessArea
         */
        this.storeBusinessArea = function (businessArea) {
            localStorage.setItem('businessArea', businessArea)
        }

        /**
         * Sets active class for all elements containing the matching business area data attribute
         * @param businessArea
         */
        this.setBusinessAreaOnElements = function (businessArea) {
            const elementList = document.querySelectorAll('[data-active-for-business-area="' + businessArea + '"]')
            elementList.forEach(function (element) {
                element.classList.add('active-business-area')
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Energy = window.Energy || {}

    window.Energy.BusinessAreaSelector = BusinessAreaSelector
})()

if (document.readyState !== 'loading') {
    new window.Energy.BusinessAreaSelector()
} else {
    document.addEventListener('DOMContentLoaded', new window.Energy.BusinessAreaSelector())
}
